module.exports = __webpack_public_path__ + "_assets/img/img-TC-card.0bbbb794.svg";